import React from "react"
import { useLocation, useParams } from "react-router-dom"
import { breadcrumbConfig } from "./breadcrumbConfig"
import { RootState, useTypedSelector } from "../../app/store"

const Breadcrumb: React.FC = () => {
  const location = useLocation()
  const params = useParams()
  const simName = useTypedSelector((state: RootState) => {
    return (
      state.authSlice.testTitle !== ""
        ? state.authSlice.testTitle
        : state.authSlice.organization.organizationName
    ) as string
  })

  // Filter out undefined values from params
  const filteredParams: Record<string, string> = Object.keys(params).reduce(
    (acc, key) => {
      if (params[key] !== undefined) {
        acc[key] = params[key] as string
      }
      return acc
    },
    {} as Record<string, string>,
  )

  const generateBreadcrumbs = (
    path: string,
    params: Record<string, string>,
  ) => {
    for (const route in breadcrumbConfig) {
      const regex = new RegExp(`^${route.replace(/:[^\s/]+/g, "([\\w-]+)")}$`)
      const match = path.match(regex)
      if (match) {
        const routeParams = route
          .split("/")
          .filter((segment) => segment.startsWith(":"))
          .reduce(
            (acc, segment, index) => {
              acc[segment.slice(1)] = match[index + 1]
              return acc
            },
            {} as Record<string, string>,
          )
        return breadcrumbConfig[route]({ ...params, ...routeParams, simName })
      }
    }
    return null
  }

  const breadcrumbs =
    generateBreadcrumbs(location.pathname, filteredParams) || []

  // Hide breadcrumbs for recruiter-admin pages since they have their own headers
  // Return empty div to maintain flex spacing in header
  if (location.pathname.includes("recruiter-admin")) {
    return <div />
  }

  return (
    <div className="breadcrumbs">
      <ul>
        {breadcrumbs.map((crumb, index) => (
          <li key={index}>
            <div className="rounded-md bg-gray-50 flex flex-row py-1 px-2 items-center justify-center text-gray-700">
              <div className="relative leading-[28px] font-medium text-lg no-underline">
                <a href={crumb.href} className="no-underline text-gray-700">
                  {crumb.label}
                </a>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Breadcrumb
